import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@roger/ui-components';
import { ArrowLeft } from 'lucide-react';

type DestructiveConfirmDialogProps = {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  pending?: boolean;
  confirmDisabled?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/** The design-system ConfirmationDialog has no destructive confirm button, and
 *  the spec asks for Remove and Archive in the destructive style.
 *  Below `md` the dialog is full screen with a Back control in the top left
 *  (spec: "the drawer and both dialogs are full screen" at 390); `md:` restores
 *  the centred 425px dialog. */
export function DestructiveConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  pending = false,
  confirmDisabled = pending,
  onConfirm,
  onCancel,
}: DestructiveConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => !isOpen && !pending && onCancel()}
    >
      <DialogContent className='inset-0 h-full max-h-none max-w-none translate-x-0 translate-y-0 content-start rounded-none md:inset-auto md:left-[50%] md:top-[50%] md:h-auto md:max-h-[calc(100dvh-2rem)] md:max-w-[425px] md:translate-x-[-50%] md:translate-y-[-50%] md:content-normal md:rounded-lg'>
        <Button
          variant='ghost'
          size='icon'
          aria-label='Back'
          className='md:hidden'
          onClick={onCancel}
          disabled={pending}
        >
          <ArrowLeft />
        </Button>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant='outline' onClick={onCancel} disabled={pending}>
            Cancel
          </Button>
          <Button
            variant='destructive'
            onClick={onConfirm}
            disabled={confirmDisabled}
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
